export enum MenuItemType {
  ITEM = 'item',
  DIVIDER = 'divider'
}
